import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    MyAccountTabListContainer as SourceMyAccountTabListContainer
} from 'SourceComponent/MyAccountTabList/MyAccountTabList.container';
import { showNotification } from 'Store/Notification/Notification.action';
import { getErrorMessage } from 'Util/Request';

/** @namespace PeggysagePwa/Component/MyAccountTabList/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // ...
});

/** @namespace PeggysagePwa/Component/MyAccountTabList/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // ...
});

/** @namespace PeggysagePwa/Component/MyAccountTabList/Container */
export class MyAccountTabListContainer extends SourceMyAccountTabListContainer {
    /**
     * Override: wait for logout before callback function (which redirects to homepage)
     */
    async handleLogout() {
        const { onSignOut, logout } = this.props;

        try {
            await logout();
            onSignOut();
        } catch (error) {
            showNotification('error', getErrorMessage(error));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountTabListContainer);
